import first from 'lodash/first';
import React from 'react';
import PropTypes from 'prop-types';
import TreeViewListItem from './TreeViewListItem';
import './TreeViewList.scss';

function TreeViewList(props) {
  const { taxonomies, onSelect, onToggle, showCountIndicator } = props;

  const getMaxLineOfCount = () => {
    if (!taxonomies) {
      return null;
    }
    return first(taxonomies).hitCount;
  };

  return (
    <ul className="treeViewList">
      {taxonomies.map((taxonomy) => {
        if (!taxonomy.visible) {
          return null;
        }

        return (
          <li key={`taxonomy-${taxonomy.id}-${taxonomy.name}`}>
            <TreeViewListItem
              onToggle={onToggle}
              onSelect={onSelect}
              taxonomy={taxonomy}
              maxLineOfCount={getMaxLineOfCount()}
              showCountIndicator={showCountIndicator}
            />
          </li>
        );
      })}
    </ul>
  );
}

TreeViewList.propTypes = {
  showCountIndicator: PropTypes.bool,
  taxonomies: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default TreeViewList;
